import { useMemo } from 'react';
import { useAllData } from '../data/loaders';
import AttributionBadge from './AttributionBadge';

/**
 * Rotating rail of 3 testimonial quotes (MO-01).
 * Different 3 per render — refreshed on navigation.
 */
export default function GlasoviRail() {
  const data = useAllData();
  const pool = data.testimonials;
  const sample = useMemo(() => {
    if (pool.length === 0) return [];
    const shuffled = [...pool].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 3);
  }, [pool]);

  if (sample.length === 0) return null;

  return (
    <section className="border-t border-neutral-200 bg-neutral-50 py-8">
      <div className="mx-auto max-w-6xl px-6">
        <h3 className="mb-4 text-xs font-medium uppercase tracking-widest text-neutral-500">
          Glasovi
        </h3>
        <div className="grid gap-6 md:grid-cols-3">
          {sample.map((q) => (
            <figure key={q.id} className="rounded-md bg-white p-4 shadow-sm">
              <blockquote
                className="border-l-2 border-axis-mo pl-3 font-serif text-sm italic leading-relaxed text-ink"
                lang={q.script === 'cyrillic' ? 'sr-Cyrl' : 'sr-Latn'}
              >
                „{q.text.slice(0, 220)}{q.text.length > 220 ? '…' : ''}"
              </blockquote>
              <figcaption className="mt-3">
                <AttributionBadge rowId={q.rowId} opstina={q.opstina} bm={q.bm} />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
